if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/* ============================================================
 * Via Firenze Algérie — Size / variant availability display
 * Greys out + strikes through option buttons that have no
 * in-stock variant for the current selection, BEFORE the
 * customer clicks. Uses the theme's existing
 * input[type='radio']:disabled + label styling.
 * Appended by store owner; safe & self-contained.
 * ============================================================ */
(function () {
  function applyAvailability(root) {
    var variantsScript = root.querySelector('script[type="application/json"]');
    if (!variantsScript) return;

    var variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (e) {
      return;
    }

    var fieldsets = Array.prototype.slice.call(root.querySelectorAll('fieldset'));
    if (!fieldsets.length) return;

    var currentSelections = fieldsets.map(function (fieldset) {
      var checked = Array.prototype.slice
        .call(fieldset.querySelectorAll('input'))
        .find(function (radio) { return radio.checked; });
      return checked ? checked.value : null;
    });

    fieldsets.forEach(function (fieldset, optionIndex) {
      var inputs = Array.prototype.slice.call(fieldset.querySelectorAll('input'));
      inputs.forEach(function (input) {
        var hasAvailable = variants.some(function (variant) {
          if (!variant.available) return false;
          if (variant.options[optionIndex] !== input.value) return false;
          return currentSelections.every(function (selectedValue, i) {
            if (i === optionIndex) return true;
            if (selectedValue === null) return true;
            return variant.options[i] === selectedValue;
          });
        });

        if (hasAvailable) {
          input.removeAttribute('disabled');
        } else {
          input.setAttribute('disabled', 'disabled');
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('variant-radios').forEach(function (root) {
      applyAvailability(root);
      if (!root.dataset.availabilityBound) {
        root.addEventListener('change', function () {
          setTimeout(function () { applyAvailability(root); }, 0);
        });
        root.dataset.availabilityBound = 'true';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
